import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, ConfirmationModal, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
const BaseConfirmDialogContent = (props)=>{
    const { t: dialogTexts } = useLocaleKeys('vendorOnboarding.adHocBillModal.confirmationDialogs');
    const ccFeeNote = props.coverCreditCardFees ? dialogTexts.sendByEmail.ccFeeNoteClient() : dialogTexts.sendByEmail.ccFeeNoteVendor();
    const recipient = dialogTexts.recipient({
        companyName: props.companyName,
        contactName: props.contactName,
        email: props.email
    });
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 8,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph1",
                testId: props.testIds.BodyIntro(),
                children: props.bodyIntro
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph1",
                weight: "bold",
                testId: props.testIds.Recipient(),
                children: recipient
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph1",
                testId: props.testIds.BodyDescription(),
                children: props.bodyDescription
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                testId: props.testIds.CcFeeNote(),
                children: ccFeeNote
            })
        ]
    });
};
export const BaseConfirmDialog = (props)=>{
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'base_confirm_dialog_confirm'
            },
            secondaryButton: {
                name: 'base_confirm_dialog_cancel'
            }
        },
        testId: props.testIds.Root(),
        title: props.title,
        content: /*#__PURE__*/ _jsx(BaseConfirmDialogContent, _object_spread({}, props)),
        textAlignCenter: false,
        width: "520px",
        secondaryButtonLabel: props.backLabel,
        secondaryButtonTestId: props.testIds.BackButton(),
        onSecondaryButtonClick: props.onBack,
        onCloseButtonClick: props.onBack,
        primaryButtonLabel: props.primaryLabel,
        primaryButtonTestId: props.testIds.PrimaryButton(),
        primaryButtonLoading: props.loading,
        primaryButtonDisabled: props.loading,
        onPrimaryButtonClick: props.onConfirm
    });
};
